import { render, staticRenderFns } from "./SubmitOtherDialog.vue?vue&type=template&id=b67e9aba&scoped=true"
import script from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
export * from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitOtherDialog.vue?vue&type=style&index=0&id=b67e9aba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e9aba",
  null
  
)

export default component.exports